import React, { Suspense, useContext } from "react";
import AppLayoutHeader from "./AppLayoutHeader";
import AppLayoutSecondaryHeader from "./AppLayoutSecondaryHeader";
import PsContext from "../../../context";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import AppRoutes from "../../appRoutes";
import { Spinner } from "react-bootstrap";

const loader = () => {
  return (
    <div className="text-center" style={{ marginTop: "calc(30vh)" }}>
      <Spinner animation="border" />
    </div>
  );
};

const AppLayout = (props) => {
  const context = useContext(PsContext);
  const userData = context.userData;

  if (context.userLogged != "1") {
    return <Navigate to="/" />;
  } else if (context.userLogged == "1") {
    return (
      <>
        <AppLayoutHeader />
        <Suspense fallback={loader()}>
          <Routes>
            {AppRoutes.map((item, i) => {
              return (
                item.element &&
                context.allowedAccess(item.module, item.action) && (
                  <Route
                    id={i}
                    path={item.path}
                    name={item.name}
                    exact={item.exact || false}
                    element={<item.element />}
                  />
                )
              );
            })}
          </Routes>
        </Suspense>
      </>
    );
  } else <>Loading..</>;
};
export default AppLayout;
